export const AVATAR_SIZES = {
  SMALL_16: 'extraSmall',
  MEDIUM_24: 'small',
  MEDIUM_32: 'medium',
  LARGE_48: 'large',
  XLARGE_64: 'extraLarge',
  XXLARGE_128: 'extraExtraLarge'
};
export const AVATAR_COLORS = {
  COLOR_1: 'color1',
  COLOR_2: 'color2',
  COLOR_3: 'color3',
  COLOR_4: 'color4',
  COLOR_5: 'color5',
  COLOR_6: 'color6',
  COLOR_7: 'color7'
};
export const DEFAULT_AVATAR_SUFFIX = /user_X\d{2,3}.png$/i;
export const REMOVED_USER_SUFFIX = /\([^)]*\)\s*$/;
export const DEFAULT_AVATAR_NAME = 'Anonymous User';
export const AVATAR_COLORS_INDEX_MAP = {
  0: AVATAR_COLORS.COLOR_1,
  1: AVATAR_COLORS.COLOR_2,
  2: AVATAR_COLORS.COLOR_3,
  3: AVATAR_COLORS.COLOR_4,
  4: AVATAR_COLORS.COLOR_5,
  5: AVATAR_COLORS.COLOR_6,
  6: AVATAR_COLORS.COLOR_7
};
export const AVATAR_GROUP_MORE_ICON_SIZE = {
  [AVATAR_SIZES.SMALL_16]: 16,
  [AVATAR_SIZES.MEDIUM_24]: 24,
  [AVATAR_SIZES.MEDIUM_32]: 32,
  [AVATAR_SIZES.LARGE_48]: 48,
  [AVATAR_SIZES.XLARGE_64]: 64,
  [AVATAR_SIZES.XXLARGE_128]: 128
};
export const AVATAR_GROUP_TRUNCATION_MAX_SIZE = {
  [AVATAR_SIZES.SMALL_16]: 3,
  [AVATAR_SIZES.MEDIUM_24]: 9,
  [AVATAR_SIZES.MEDIUM_32]: 9,
  [AVATAR_SIZES.LARGE_48]: 99,
  [AVATAR_SIZES.XLARGE_64]: 99,
  [AVATAR_SIZES.XXLARGE_128]: 99
};
export const AVATAR_GROUP_TRUNCATION = {
  NUMERIC: 'numeric',
  DOTTED: 'dotted'
};
export const AVATAR_GROUP_VARIANTS = {
  COMPACT: 'compact',
  EXTENDED: 'extended'
};
export const AVATAR_GROUP_VARIANTS_MAX_SIZE = {
  [AVATAR_GROUP_VARIANTS.COMPACT]: 3,
  [AVATAR_GROUP_VARIANTS.EXTENDED]: 6
};
//# sourceMappingURL=constants.js.map